import jwtDecode from 'jwt-decode';


export function toVND(num: number): string {
  return `${Math.floor(num).toLocaleString('vi')}VND`
}

export function getStudentIdFromToken(token: string): string | null {
  try {
    return jwtDecode<{ user_id: string }>(token).user_id
  } catch (e) {
    return null
  }
}

export function uppercase1stLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function isEmptyString(str: string) {
  return str === ''
}
